<template>
  <div :class="['app-container', { 'bdc-list-page': isBdc }]">
    <!-- 工具栏 -->
    <div class="filter-container" :class="{ 'bdc-filter-bar': isBdc }">

      <el-button class="filter-item" size="small" type="primary" icon="el-icon-circle-plus-outline" @click="handlePublish">发布站内信</el-button>

      <!-- 表格header 筛选 -->
      <div v-if="!isBdc" class="filterTableHeader" style="float:right;">
        <el-popover width="400" trigger="click">
          <el-button slot="reference" size="small" icon="el-icon-s-grid" style="font-size: 16px;padding:5px 10px;" title="筛选列"><i class="el-icon-caret-bottom"></i></el-button>
          <el-checkbox-group class="checkbox-table-headers" v-model="checkboxTitle">
              <el-checkbox v-for="(item,index) in tableTheadOptions" :key="index" :label="item" >{{item[Object.keys(item)[0]]}}</el-checkbox>
          </el-checkbox-group>
        </el-popover>
      </div>
    </div>

    <!-- 表格 -->
    <div ref="bdcTableArea" :class="{'bdc-table-area': isBdc}">
    <el-table class="grayTableTile" size="mini"  v-loading="listLoading" :data="tableList" border style="width: 100%" :height="tableHeightDaily">
      <el-table-column v-for="(item,index) in tableTheads" :key="index" :label="item[Object.keys(item)[0]]" :prop="Object.keys(item)[0]">
        <template slot-scope="scope" >
          <span v-if="Object.keys(item)[0] == 'content'" style="color:#646cf5;cursor: pointer;" @click="handleDialog(scope.row)">{{ scope.row[Object.keys(item)[0]] | neirongsuojian}}</span>
          <span v-else-if="Object.keys(item)[0] == 'isRead'">{{ scope.row[Object.keys(item)[0]] | shifouyidu}}</span>
          <span v-else>{{ scope.row[Object.keys(item)[0]]}}</span>
        </template>
      </el-table-column>

      <el-table-column label="操作" width="160px" class-name="small-padding fixed-width" fixed="right">
        <template slot-scope="scope">
          <div class="bdc-table-op-cell">
            <el-button type="text" class="bdc-table-op-danger" @click="handleDelete(scope.row)">删除</el-button>
          </div>
        </template>
      </el-table-column>

    </el-table>
    </div>

     <!-- 分页 -->
    <bdc-table-footer>
      <template #actions>
        <el-popover width="400" trigger="click">
          <bdc-column-filter-button slot="reference" />
          <el-checkbox-group class="checkbox-table-headers" v-model="checkboxTitle">
              <el-checkbox v-for="(item,index) in tableTheadOptions" :key="index" :label="item" >{{item[Object.keys(item)[0]]}}</el-checkbox>
          </el-checkbox-group>
        </el-popover>
      </template>
      <pagination v-show="total>0" :auto-scroll="false" :background="!isBdc" :total="total" :page.sync="listQuery.pageNo" :limit.sync="listQuery.pageSize" :class="isBdc ? 'bdc-table-pagination' : ''" />
    </bdc-table-footer>

    <!-- 信息详情 详细弹窗 -->
    <el-dialog class="dialog bdc-mail-detail-dialog" :title="title" v-if="dialogVisible" :visible.sync="dialogVisible" width="50%"  :append-to-body="true" :close-on-click-modal="false" @close="handleClosed">
      <div class="content" v-html="content" ></div> 
      <!-- 按钮组 -->
      <div class="dialog-butn-box">
          <el-button size="small" type="primary" @click="handleClosed">确认</el-button>
      </div>
    </el-dialog>

    <!-- 发布站内信 -->
    <el-dialog title="发布站内信" v-if="dialogPublish" :visible.sync="dialogPublish" width="50%" top="5vh">
      <el-form :model="xinjian" ref="xinjian" :rules="rules" label-width="100px">
        <el-form-item label="信件标题"  prop="title">
          <el-input v-model="xinjian.title" style="width:98%"></el-input>
        </el-form-item>
        <el-form-item label="信件正文" prop="content">
          <markdown-editor v-model="xinjian.content" mode="wysiwyg" language="zh-CN"  height="500px" style="width:98%" @input="handleDescribe($event, 'content')" />
        </el-form-item>
      </el-form>
       <!-- 按钮组 -->
      <div class="dialog-butn-box">
        <el-button type="primary" @click="handleSave">确认</el-button>
        <el-button @click="dialogPublish=false">关闭</el-button>
      </div>
    </el-dialog>
    
  </div>
</template>

<script>
import MarkdownEditor from '@/components/MarkdownEditor'
import Pagination from '@/components/Pagination'
import BdcTableFooter from '@/components/BdcTableFooter'
import BdcColumnFilterButton from '@/components/BdcTableFooter/BdcColumnFilterButton'
import { arrSlice } from '@/filters'
import Store from '@Sys~/store'
import { ajax_messagelist, ajax_messageinfo, ajax_messagedelete, ajax_messagemerge} from '@Sys~/api/stationLetter'
import bdcListTableHeight from '@Sys~/utils/bdcListTableHeight'
// table header
const defaultFormThead = [
  {title: '标题'},
  {content: '正文'},
  {addTime: '创建时间'},
  {isRead: '是否已读'}
]

// 弹窗默认的数据内容
const defaultFrom = {
  title: '', // 标题
  content:'', // 内容
  systemId: process.env.VUE_APP_PROJECT_TYPE == 'bdc' ? 24 : process.env.VUE_APP_PROJECT_TYPE == 'ads' ? 26 : process.env.VUE_APP_PROJECT_TYPE == 'gms' ? 25 : ''
}
const name = Store.getters.currentRoute.name
console.log('缓存===站内信箱', name)
export default {
  name:name,
  mixins: [bdcListTableHeight],
  components: {Pagination, BdcTableFooter, BdcColumnFilterButton, MarkdownEditor},
  data() {
    return {
       // 表格
      listLoading: false,
      originalCaseTable: [], // 排序原始数据
      caseTable: [], // 存放后端一次性返回的所有数据
      handCaseTable: [], // 存放处理假分页后的数据(等距切割)
      tableData: [], // 切割后页面应展示的数据
      tableTheadOptions:defaultFormThead,
      checkboxTitle:defaultFormThead,
      tableTheads:defaultFormThead,

      isRead:0,
      
      total: 0,
      listQuery: {
        pageNo: 1,
        pageSize: 10
      },

      // 详细信息弹窗
      title: "",
      content: "",
      dialogVisible: false,

      // 发布站内信
      dialogPublish: false,
      xinjian:{},
      rules: {
        title:[{required: true, trigger: ['blur', 'change'], message: '请填写信件标题'}],
        content:[{required: true, trigger: ['blur', 'change'], message: '请填写信件正文'}],
      }
    }
  },

  filters:{
    neirongsuojian(value) {
      return value.replace(/<[^<>]+>|[&nbsp;]/g, '').substring(0, 25) + "..."
    },

    shifouyidu(value) {
      if (value == "0") {
        return "未读";
      } else if (value == "1") {
        return "已读";
      }
    },

  },

  watch: {
    // 筛选table header
    checkboxTitle(valArr) {
      this.tableTheads = this.tableTheadOptions.filter(i => JSON.stringify(valArr).indexOf(JSON.stringify(i)) > -1)
      // console.log('=======',this.tableTheads)
    }
  },
  computed: {

    isBdc() {
      return process.env.VUE_APP_PROJECT_TYPE === 'bdc'
    },

    // 筛选列表表
    tableList() {
      let caseTable = this.caseTable
      this.total = caseTable.length
      // 将一维数组切割成二维数组
      this.handCaseTable = arrSlice(caseTable, this.listQuery.pageSize)
      this.tableData = this.handCaseTable[this.listQuery.pageNo - 1]
      // if (this.tableData) {
      //   this.tableData.map(e => {
      //     if (e.systemName == "") {
      //       this.$set(this.checkList, e.id, [])
      //     } else {
      //       this.$set(this.checkList, e.id, e.systemName.split(","))
      //     }
      //   });
      // }
      return this.tableData

    },
  },
  created() {
    this.getList()
  },
  methods: {
    // 获取列表
    getList() {
      this.listLoading = true
      ajax_messagelist().then(response => {
        this.listLoading = false
        if (response.code == 1) {
          this.caseTable = response.data;
          this.originalCaseTable = JSON.parse(JSON.stringify(response.data))
          this.total = response.data.length;

          // 将一维数组切割成二维数组
          // this.handCaseTable = arrSlice(this.caseTable, this.listQuery.pageSize)
          // this.tableData = this.handCaseTable[this.listQuery.pageNo-1]
        }
      });
    },

    // 查看站内信详情
    handleDialog(row) {
      this.isRead = row.isRead
      this.dialogVisible = true
      ajax_messageinfo(row.id).then(response => {
        if(response.code == 1) {
          this.title = response.data.title
          this.content = response.data.content
        }
      })
    },

    // 关闭详情弹窗
    handleClosed() {
      this.dialogVisible = false;
      if (this.isRead == 0) {
        this.getList()
      }
      if (process.env.VUE_APP_PROJECT_NAME === 'file') {
        this.$store.dispatch('permission/generateRoutesFile').then(res => {
          this.$router.addRoutes(res)
        })
      } else {
        this.$store.dispatch('permission/generateRoutesSys').then(res => {
          this.$router.addRoutes(res)
        })
      }
    },

    // 删除站内信
    handleDelete(row) {
      this.$confirm("此操作将删除该条信件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
          ajax_messagedelete(row.id).then(response => {
              if (response.code == 1) {
                this.$message({
                  message: "删除成功",
                  type: "success"
                });
                this.getList();
              } else {
                this.$message({
                  type: "warning",
                  message: response.msg
                });
              }
            }
          );
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    },
    
    // 发布站内信
    handlePublish() {
      this.dialogPublish = true
      this.xinjian = JSON.parse(JSON.stringify(defaultFrom))
      this.$nextTick(() => {
        this.$refs['xinjian'].clearValidate()
      })
    },

    // 监听信件正文
    handleDescribe(val, prop) {
        if(val) {
          this.$refs['xinjian'].clearValidate(prop)
        } else {
          // this.$refs['xinjian'].validate(prop)
        }
    },

    // 确认发布
    handleSave() {
      this.$refs['xinjian'].validate((valid) => {
        if (valid) {
          ajax_messagemerge(this.xinjian).then(response => {
            if(response.code == 1) {
              this.$message({
                message: "添加成功",
                type: "success"
              });

              this.dialogPublish = false
              this.getList()
            }
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>

  .dialog{
    ::v-deep .el-dialog__body{
      padding: 10px 20px;
    }
    &.bdc-mail-detail-dialog ::v-deep .el-dialog__header {
      position: relative;
      padding-right: 48px;
      .el-dialog__title {
        display: block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        line-height: 24px;
      }
      .el-dialog__headerbtn {
        position: absolute;
        right: 16px;
        top: 50%;
        transform: translateY(-50%);
        z-index: 1;
      }
    }
    .content{
      margin-bottom: 30px;
      min-height: 200px;
      line-height: 1.5;
    }
  }
</style>